import { NgModule } from '@angular/core';
import { NdtTabRouterDirective } from './tab-router.directive';

@NgModule({
   declarations: [NdtTabRouterDirective],
   imports: [],
   exports: [NdtTabRouterDirective],
})
export class TabRouterDirectiveModule {}
